import { FC } from 'react';
import { ButtonLink } from '@domgen/base-design-system-2.0/atoms/ButtonLink';
import { MouseIcon } from '../../../assets/icons/MouseIcon';
import { V2Cta, V2Frame } from '../sections/v2';
import { LandingVariantProps } from './types';

/**
 * LP3 new-UX (`link-only-v1`) — online only, shown while the call centre is
 * closed (`afterHours.lp`) or wherever the payload configures it. The heading
 * is the online copy plus a ` **` anchoring the registration-flavoured
 * footnote (swapped in via this variant's phoneNumberAsterix override), with
 * the "phone lines are currently closed" line under the button. The single
 * button uses the primary/phone colour per the approved design.
 */
export const LinkOnlyV1: FC<LandingVariantProps> = ({ data, copy, onCtaClick }) => (
  <V2Frame
    data={data}
    copy={copy}
    singleCta
    cta={
      <V2Cta heading={`${copy.onlineCopy} **`} subCopy={copy.linesClosedMessage}>
        <ButtonLink
          leftIcon={<MouseIcon />}
          href={data.ctaOnlineLink}
          variant="primary"
          id="online-link-cta"
          onClick={() => onCtaClick('online', data.ctaOnlineLink)}
        >
          {copy.ctaOnlineText}
        </ButtonLink>
      </V2Cta>
    }
  />
);
